import type {TrackDispatcher} from '@gaia/hooks/useTracks';

export default function (
    {properties}: UpdateWaypointPropertiesAction,
    setWaypoints: React.Dispatch<React.SetStateAction<{[localId: string]: Waypoint}>>,
    trackPoints: {[localId: string]: Waypoint},
    trackDispatcher: TrackDispatcher
) {
    const {localId} = properties;

    if (trackPoints[localId]) {
        const trackPointProperties = properties as Partial<TrackPoint['properties']>;
        return trackDispatcher({
            type: 'updatePointProperties',
            properties: {
                ...trackPointProperties,
                localId: properties.localId,
                trackLocalId: trackPoints[localId].properties.trackLocalId!,
            },
        });
    } else {
        setWaypoints((latestWaypoints) => {
            return {
                ...latestWaypoints,
                [localId]: {
                    ...latestWaypoints[localId],
                    properties: {
                        ...latestWaypoints[localId].properties,
                        ...properties,
                    },
                },
            };
        });
    }

    return [localId];
}
